import UserSessionService from "../../UserSessionService";
import WsService from "../../WsService";
import BopCategory from "../../../domain/Transaction/BopCategory";
import BasicAuthGenerator from "utils/BasicAuthGenerator";
import BopCategoryResponse from "domain/Transaction/BopCategoryResponse";

const ENDPOINT_BASE = "/bop-category";

export default class BopCategoryService {

    static get(idType, amount, isSelfToSelf) {

        let endpoint = ENDPOINT_BASE + "?amount=" + amount + "&id-type=" + idType + '&is-self-to-self='+isSelfToSelf;
        let transactionHeaders = UserSessionService.retrieveTransactingHeaders();
        let headers = {
            ...transactionHeaders
        };

        return WsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                return new BopCategory(response)
            },
            response => {
                return response;
            });
    }

    static getForTransaction(idType, amount, isSelfToSelf) {

        let endpoint = ENDPOINT_BASE + "?amount=" + amount + "&id-type=" + idType + "&is-self-to-self="+isSelfToSelf;
        let transactionHeaders = UserSessionService.retrieveTransactingHeaders();
        let registrationHeaders = UserSessionService.retrieveRegisteringAuth();
        let headers = {
            ...transactionHeaders,
            "Authorization": BasicAuthGenerator.create(registrationHeaders["registering-partner-username"], registrationHeaders["registering-partner-password"]),
        };

        return WsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                return new BopCategory(response)
            },
            response => {
                return response;
            });
    }

    static getForIdType(idType) {

        let endpoint = ENDPOINT_BASE + "?id-type=" + idType;
        let registrationHeaders = UserSessionService.retrieveRegisteringAuth();
        let headers = {
            "Authorization": BasicAuthGenerator.create(registrationHeaders["registering-partner-username"], registrationHeaders["registering-partner-password"]),
        };
        return WsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                let returnObject = [];
                response.forEach(singleResponse => {
                    returnObject.push(new BopCategoryResponse(singleResponse));
                });
                return returnObject;
            },
            response => {
                return response;
            });
    }
}
